import { useState, useEffect } from "react";
import "./Carousel.scss"; // Importamos los estilos
import lep1 from "../../../../assets/landing/lep1.png"
import lep2 from "../../../../assets/landing/lep2.png"
import lep3 from "../../../../assets/landing/lep3.png"
import lep4 from "../../../../assets/landing/lep4.png"
import { content } from "html2canvas/dist/types/css/property-descriptors/content";


const slides = [
  {
    title: "¿Qué es la Ley del Espectáculo Público (LEP)?",
    content:
      "La Ley del Espectáculo Público (LEP) es una ley que busca apoyar al sector de las artes escénicas en Colombia —eso incluye teatro, danza, música en vivo, circo y más— usando parte del dinero que se recauda en boletería de conciertos, obras y eventos en vivo. ¿Cómo? Redistribuyendo esos recursos para que lleguen a quienes hacen posible el arte: artistas, grupos, salas, colectivos, gestores y productores.",
    content2: "¿En qué te beneficia? Gracias a la LEP, se han financiado cosas como: Mejoras en salas y teatros: para que más lugares estén bien equipados y en buen estado. Recursos para producir eventos escénicos: apoyo económico para que pongas en escena esa obra, ese concierto o ese montaje que tanto sueñas. Apoyo para circular: si quieres llevar tu trabajo a otra ciudad, otro país o simplemente a nuevos públicos, la LEP puede darte una mano.",
    image: lep1, // Cambia la ruta a tu imagen
  },
  {
    title: "¿Quién puede participar?",
    content:
      "Artistas, agrupaciones, colectivos, salas de teatro, gestores culturales, productores escénicos… si haces parte del ecosistema del espectáculo en vivo, esta ley te abre la puerta.",
    content2: "¿Cómo funciona? Cada vez que alguien compra una boleta para un evento en vivo que sea igual o mayor a $150.000 COP, el 10% de este valor entra a un fondo. Ese fondo luego se usa para convocar, financiar y fortalecer proyectos de artes escénicas. A través de convocatorias públicas, vos podés presentar tu propuesta y postularte para recibir recursos.",
    image: lep2, // Cambia la ruta a tu imagen
  },
	{
    title: "¿Y si nunca he participado?",
    content:
      "No te preocupes. Para eso creamos esta guía y este espacio: para explicarte todo paso a paso, sin enredos, con lenguaje claro, ejemplos y recomendaciones que te pueden servir.",
    content2: "Explora la guía. Conoce cómo aplicar. Y anímate a participar.",
    image: lep3, // Cambia la ruta a tu imagen
  },
	{
    title: "¿Un Comité LEP?",
    content:
      "Sí, el Comité de la Contribución Parafiscal de los Espectáculos Públicos de las Artes Escénicas es la instancia donde se avala la destinación de los recursos, se apoya la administración de estos y se da el visto bueno a las propuestas que serán beneficiados con los recursos LEP.",
    image: lep4, // Cambia la ruta a tu imagen
  },
];

export const CarouselLEP = () => {
  const [index, setIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    setIsAnimating(true);
    const interval = setInterval(() => {
      setIsAnimating(false); // Oculta antes de cambiar
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex + 1) % slides.length);
        setIsAnimating(true);
      }, 300); // Retardo antes del cambio
    }, 5000);
    return () => clearInterval(interval);
  }, [index]);

  const nextSlide = () => {
    setIsAnimating(false);
    setTimeout(() => {
      setIndex((prevIndex) => (prevIndex + 1) % slides.length);
      setIsAnimating(true);
    }, 300);
  };

  const prevSlide = () => {
    setIsAnimating(false);
    setTimeout(() => {
      setIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
      setIsAnimating(true);
    }, 300);
  };

  return (
    <div className={"carousel-container2"}>
      <div className={"carousel-slide2"}>
        {/* Imagen con animación */}
        <img
          src={slides[index].image}
          alt="Slide"
          className={`${"carousel-image2"} ${isAnimating ? "show2" : ""}`}
        />

        {/* Texto con animación */}
        <div className={`${"carousel-text2"} ${isAnimating ? "show2" : ""}`}>
          <h2 style={{backgroundColor: '#d7d4d4', padding: '10px', borderRadius: '10px'}}>{slides[index].title}</h2>
          <p>
            {slides[index].content}
            <br />
            <br />
            {slides[index].content2}
          </p>
        </div>

      </div>

      {/* Botones de navegación */}
      <div className={"carousel-buttons2"}>
        <button onClick={prevSlide}>◀</button>
        <button onClick={nextSlide}>▶</button>
      </div>
    </div>
  );
}